import React, { useEffect, useRef, useState } from "react";
import styles from "./styles/InputFileMulti.module.css";
import Button from "../button/Button";
import CloseButton from "../close_button/CloseButton";
import { getMaxId } from "../../../utils/utils";
import { useTranslation } from "react-i18next";

// _______________________________________________________________________________________________________ FileMarker
const FileMarker = ({ fileName, id, handleDelete }) => {
    return (
        <div className={`${styles.file_marker_container} flex-container`}>
            <p className={`${styles.file_name}`}>{fileName}</p>
            <div className={`${styles.close_button_container} flex-container`}>
                <CloseButton
                    size={"small"}
                    tab={true}
                    onClickFuction={() => handleDelete(id)}
                    tabBackground={true}
                />
            </div>
        </div>
    );
};
// _______________________________________________________________________________________________________ InputFileMulti
const InputFileMulti = ({
    label,
    inputId,
    inputValue = [],
    handleChangeFunction,
    required,
}) => {
    const [currentInputValue, setCurrentInputValue] = useState(inputValue);
    const fileInputRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        setCurrentInputValue(inputValue);
    }, [inputValue]);

    const handleFileContent = (event) => {
        const maxId = getMaxId(currentInputValue);
        const currentId = maxId + 1;
        const file = event?.target?.files?.[0];
        if (
            file &&
            (file.type === "application/pdf" || file.type === "image/jpeg")
        ) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const content = e.target.result;
                const newFile = {
                    id: currentId,
                    fileName: file.name,
                    base64Content: content.split(",")[1],
                };

                const updatedArray = [...currentInputValue, newFile];

                handleChangeFunction({
                    target: {
                        name: inputId,
                        value: updatedArray,
                    },
                });
                fileInputRef.current.value = "";
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDelete = (id) => {
        const updatedArray = currentInputValue.length
            ? currentInputValue.filter((item) => item.id !== id)
            : [];

        handleChangeFunction({
            target: {
                name: inputId,
                value: updatedArray,
            },
        });
    };

    return (
        <div className={`${styles.main_input_container} v-flex-container`}>
            <p className={`${styles.input_label}`}>
                {label}
                {label ? ":" : ""}
            </p>

            <div className={`${styles.input_files_container} flex-container`}>
                <div className={`${styles.files_container}`}>
                    {currentInputValue?.length ? (
                        currentInputValue.map((file) => (
                            <FileMarker
                                key={file?.id}
                                fileName={file.fileName}
                                id={file?.id}
                                handleDelete={handleDelete}
                            />
                        ))
                    ) : (
                        <></>
                    )}
                </div>
                <div className={`${styles.input_container} `}>
                    <div className={`${styles.file_button}`}>
                        <Button
                            body={t("select file")}
                            size="small"
                            type="button"
                            disabled={currentInputValue?.length >= 3}
                            disableHTML={currentInputValue?.length >= 3}
                            onClickFuction={() => fileInputRef.current.click()}
                            color={required ? "red" : undefined}
                        />
                    </div>

                    <input
                        className={`${styles.input_element}`}
                        type="file"
                        accept=".pdf,.jpg,.jpeg"
                        name={inputId}
                        id={inputId}
                        onChange={handleFileContent}
                        ref={fileInputRef}
                    />
                </div>
            </div>
        </div>
    );
};

export default InputFileMulti;
